import { render } from "./InvestorProfileShimmer.vue?vue&type=template&id=3c0e8c04"
import script from "./InvestorProfileShimmer.vue?vue&type=script&lang=js"
export * from "./InvestorProfileShimmer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\src\\Vue Project\\inalife-admin-dashboard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__